/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */
import { Component } from '@appCanvasCommon/component-system/Component';
import { ComponentInterface } from '@appCanvasCommon/interfaces/component.interface';
import { CanvasAngularLand } from '../../../../app-data/interfaces/canvas-angular-land';
import { AbstractApplication } from '@appCanvasCommon/core/AbstractApplication';
import { IExportContext } from '@appCanvasCommon/export/IExportContext';
import { Container } from 'pixi.js-legacy';
import { LayerPaths } from '@appPlanApplication/LayerPaths';
import { TicketPlanApplication } from '@appPlanApplication/TicketPlanApplication';
/**
 * This export component hides the swimlane labels node when the capture is printing the 2nd column per row
 * Otherwise the swimlane labels would be copied vertically as the camera scans the plan area.
 */
export class HideSwimlaneLabel extends Component implements ComponentInterface {
	/**
	 * Invoked for each tile captured.
	 * @param canvasAngularLand
	 * @param application
	 * @param context
	 */
	public onExportTile(
		canvasAngularLand: CanvasAngularLand,
		application: AbstractApplication,
		context: IExportContext
	): void {
		if (context.isFirstTileInRow) {
			this.enableLabels(application);
			return;
		}

		this.disableLabels(application);
	}
	/**
	 * Invoked once the export is finished.
	 * @param canvasAngularLand
	 * @param application
	 */
	public onExportComplete(canvasAngularLand: CanvasAngularLand, application: AbstractApplication): void {
		this.enableLabels(application);
	}

	/**
	 * Helper method to enable all swimlane labels
	 * @param application
	 * @private
	 */
	private enableLabels(application: AbstractApplication): void {
		const app: TicketPlanApplication = application as TicketPlanApplication;
		app?.swimlanes?.showAllLabels();
	}
	/**
	 * Helper method to disable all swimlane labels
	 * @param application
	 * @private
	 */
	private disableLabels(application: AbstractApplication): void {
		const app: TicketPlanApplication = application as TicketPlanApplication;
		app?.swimlanes?.hideAllLabels();
	}
}
